var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconVector = function SvgIconVector(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.922 12.176 9.734-10.713 13.992 15.4 3.194-3.516L44 27.602l-12.951-2.377 3.194-3.515-9.587-10.551-9.734 10.713L0 5.45 4.405.602l10.517 11.574Z",
    fill: "#111"
  })));
};
export default SvgIconVector;